import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-100ccac4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sidebar-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Trailer Solutions")
], -1))
const _hoisted_2 = { class: "sidebar-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "sidebar",
    style: _normalizeStyle(_ctx.addedStyle)
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "sidebar-content", {}, undefined, true)
    ])
  ], 4))
}